import { useForm } from '@mantine/form';
import { useEffect, useState } from 'react';
import { CustomerSettingType } from '@/services/enums';
import {
  CustomerSettingsParams,
  RoomsRole,
  RoomsRoleAccess
} from '@/services/api/customerSettingsApiArea/types';
import { customerSettingsApiArea } from '@/services/api/customerSettingsApiArea';

export type TFormValuesShareLinks = {
  isDisabled: boolean;
  restrictions: RoomsRole[];
  initRestrictions: RoomsRole[];
};
type Return = [
  RoomsRoleAccess | undefined,
  boolean,
  () => Promise<void>,
  (id: number) => Promise<void>
];

export const useRestrictRoomsByRoles = (CustomerId?: number): Return => {
  const [settings, setSettings] = useState<RoomsRoleAccess | undefined>(undefined);
  const [isLoading, setLoading] = useState(true);

  const form = useForm<TFormValuesShareLinks>({
    validateInputOnChange: true,
    initialValues: {
      isDisabled: false,
      restrictions: [],
      initRestrictions: []
    }
  });

  const loadSettings = async () => {
    const params = {
      id: CustomerId,
      extended: true
    };

    const { Response } = await customerSettingsApiArea().GetCustomer(params);
    const settings = Response.Data.Settings;

    if (!settings) return;

    setSettings(settings.RoomsRoleAccess);

    if (!settings.RoomsRoleAccess) return;

    const values = {
      restrictions: settings.RoomsRoleAccess?.Roles,
      initRestrictions: settings.RoomsRoleAccess?.Roles
    };
    form.setValues(values);
  };

  const deleteRule = async (id: number) => {
    if (!CustomerId || !settings || isLoading) return;

    const params: CustomerSettingsParams = {
      CustomerId,
      Type: CustomerSettingType.RoomsAccess,
      Settings: {
        RoomsRoleAccess: {
          IsDisabled: settings.IsDisabled,
          Roles: settings.Roles?.filter((rule) => rule.Id !== id) || []
        }
      }
    };

    await customerSettingsApiArea().SaveCustomerSettings(params).then(loadSettings);
  };

  useEffect(() => {
    if (!CustomerId) return;
    setLoading(true);

    loadSettings().finally(() => setLoading(false));
  }, [CustomerId]);

  return [settings, isLoading, loadSettings, deleteRule];
};
